// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demo-table-expand[data-v-7413c080]{font-size:0}.demo-table-expand label[data-v-7413c080]{width:90px;color:#99a9bf}.demo-table-expand .el-form-item[data-v-7413c080]{margin-right:0;margin-bottom:0;width:50%}", ""]);
// Exports
module.exports = exports;
